import { render, staticRenderFns } from "./document-detail.page.vue?vue&type=template&id=1281de4b&"
import script from "./document-detail.page.vue?vue&type=script&lang=ts&"
export * from "./document-detail.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports